export default __webpack_public_path__ + "static/media/bg_footer.620da3e7.png";